import Vue from "vue";
import VueRouter from "vue-router";

import { routes } from "./routes";
import store from "./store";

Vue.use(VueRouter);

let router = new VueRouter({
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  var authorizedRoles = to.meta.roles;
  // retrieve from store in form of promise
  store.dispatch("getUser").then(function(response) {
    if (authorizedRoles && !store.getters.isAuthorized(authorizedRoles)) {
      console.log(response);
      console.log(store.getters.isAuthorized(authorizedRoles));
      if (store.getters.isAuthenticated) {
        // user is logged in but not allowed
        //$rootScope.$broadcast(AUTH_EVENTS.notAuthorized);
        next("/not-authorized");
      } else {
        // user is not logged in
        //$rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);
        //next(process.env.VUE_APP_BASE_URI + "/login");
        window.location.href =
          process.env.VUE_APP_BASE_URI +
          "/home/login?returnUrl=" +
          window.location.href;
      }
    } else {
      next();
    }
  });
});

export default router;
